import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Stack from "@mui/material/Stack";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { Gear as DetailsIcon } from "@phosphor-icons/react/dist/ssr/Gear";
import { useFormik } from "formik";
import { FC } from "react";

import { Dialog } from "@mui/material";
import {
	LAYER_STYLE_TYPE,
	LineCategoryConfigs,
} from "~ui-components/types/__generated/gql/graphql";
import { LineSortable } from "./sortable/line";
import { PointSortable } from "./sortable/point";
import { PolygonSortable } from "./sortable/polygon";

export interface CategoryCustomLegendProps {
	type:
		| LAYER_STYLE_TYPE.LINE_CATEGORY
		| LAYER_STYLE_TYPE.POLYGON_CATEGORY
		| LAYER_STYLE_TYPE.POINT_CATEGORY;
	form: ReturnType<typeof useFormik<Pick<LineCategoryConfigs, "symbolValues">>>;
	onRowsChange: (rows: GridRowModel[]) => void;
	onCancel: () => void;
}

export const CategoryCustomLegend: FC<CategoryCustomLegendProps> = ({
	type,
	form,
	onRowsChange,
	onCancel,
}) => {
	return (
		<Dialog
			open
			fullScreen
			scroll="body"
			onClose={onCancel}>
			<Stack
				direction={{ xs: "column", md: "row" }}
				spacing={4}
				sx={{ position: "relative", m: "44px" }}>
				<Card sx={{ width: "100%" }}>
					<CardHeader
						avatar={
							<Avatar>
								<DetailsIcon fontSize="var(--Icon-fontSize)" />
							</Avatar>
						}
						title="Map details"
					/>
					<CardContent>
						{type === LAYER_STYLE_TYPE.LINE_CATEGORY && (
							<LineSortable
								form={form}
								onRowsChange={onRowsChange}
							/>
						)}
						{type === LAYER_STYLE_TYPE.POLYGON_CATEGORY && (
							<PolygonSortable
								form={form}
								onRowsChange={onRowsChange}
							/>
						)}
						{type === LAYER_STYLE_TYPE.POINT_CATEGORY && (
							<PointSortable
								form={form}
								onRowsChange={onRowsChange}
							/>
						)}
					</CardContent>
					<CardActions sx={{ justifyContent: "flex-end" }}>
						<Button
							color="secondary"
							onClick={onCancel}>
							Cancel
						</Button>
						<Button
							variant="contained"
							onClick={() => {
								form.handleSubmit();
							}}>
							Save changes
						</Button>
					</CardActions>
				</Card>
			</Stack>
		</Dialog>
	);
};
